import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FrontPhoneGradingDeductionComponent} from './FrontPhoneGradingDeduction.component'
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatSortModule, MatTableModule } from "@angular/material";
  import { UiSwitchModule } from 'ngx-ui-switch';
  import {DataTableModule} from 'angular2-datatable';
  import { MyDatePickerModule } from 'mydatepicker';
  import { HttpClientModule } from '@angular/common/http';
const routerConfig = [{
  path: '',
  component: FrontPhoneGradingDeductionComponent
}];

@NgModule({
  imports: [
    CommonModule ,FormsModule ,TooltipModule,  MyDatePickerModule,
     MatTableModule ,MatSortModule,MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,ReactiveFormsModule,
    RouterModule.forChild(routerConfig),
    UiSwitchModule,HttpClientModule,DataTableModule
  ] ,
  declarations: [
    FrontPhoneGradingDeductionComponent
    //TruncatePipe
  ],
  exports: [
    FrontPhoneGradingDeductionComponent ,MatSortModule
  ],
  providers: []

})

export class FrontPhoneGradingDeductionModule { }
